export const starIcon = (
  <svg
    preserveAspectRatio="xMidYMid meet"
    data-bbox="21 20 159.3 160"
    viewBox="21 20 159.3 160"
    height="60"
    width="60"
    xmlns="http://www.w3.org/2000/svg"
    data-type="color"
    role="presentation"
    aria-hidden="true"
    aria-label=""
  >
    <g>
      <path
        fill="#231f20"
        d="M180.3 99.4c0 1.3-43 2.7-43 2.7-18.7 0-34.1 15.3-34.1 34.1 0 0-1.3 43.8-2.7 43.8s-2.7-43.8-2.7-43.8c0-18.7-15.3-34.1-34.1-34.1 0 0-42.7-1.3-42.7-2.7s42.7-2.7 42.7-2.7c18.7 0 34.1-15.3 34.1-34.1 0 0 1.4-42.7 2.8-42.6 1.3 0 2.6 42.6 2.6 42.6 0 18.7 15.3 34.1 34.1 34.1 0 0 42.9 1.3 43 2.7Z"
        data-color="1"
      ></path>
    </g>
  </svg>
);
